import {
    SET_KEYCLOAK
} from '../actions/type'

const initialState = {}

const authentication = (state = initialState, action) => {
    switch (action.type) {
        case SET_KEYCLOAK: {
            const payload = action.payload;
            return payload.keycloak;
        }
        default:
            return state
    }
}

export default authentication